import React from "react";
import { compose } from "redux";
import { connect } from "react-redux";
import { useNavigate } from "react-router-dom";
import { setUser } from "../../store/modules/user/actions";
import { withFirebase } from "../../services/firebase";

import SignIn from "../../components/PaidSignIn";
import { useState } from "react";
import { useEffect } from "react";
import ServerCall from "../../serverCall";
import toast from "react-hot-toast";

const SignInContainer = (props) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [userId, setUserId] = useState(null);

  const navigate = useNavigate();

  const handleChange = (e) => {
    e.target.name === "email" && setEmail(e.target.value);
    e.target.name === "password" && setPassword(e.target.value);
  };

  const isPaidVerification = async () => {
    const serverCall = ServerCall();

    try {
      const response = await serverCall.customAxios.post(
        "/check-subscription",
        { email: email },
        {
          headers: { "Content-Type": "application/json" },
        }
      );
      return response.data[0];
    } catch (error) {
      console.error(error);
    }
  };

  const handleSubmit = () => {
    const { firebase, setUser } = props;
    firebase
      .signIn(email, password)
      .then(async (response) => {
        const user = response?.user;
        // Fetch the ID token and get custom claims
        const idTokenResult = await user?.getIdTokenResult();
        const claims = idTokenResult?.claims;
        if (claims?.role === "admin") {
          localStorage.setItem("token", idTokenResult?.token);
          return "admin";
        }
        return localStorage.setItem("token", response.user.accessToken);
      })
      .then((response) => {
        if (response === "admin") {
          return {
            role: "admin",
            querySnapshot: firebase.getAuth().currentUser,
          };
        }
        return firebase.getAuth().currentUser;
      })
      .then(async (querySnapshot) => {
        if (querySnapshot.role === "admin") {
          setUser({ ...querySnapshot.querySnapshot, role: "admin" });
          toast.success("Welcome! You have successfully signed in.");
          return;
        }
        const isPaidUser = await isPaidVerification();
        if (isPaidUser?.isActive) {
          setUser(querySnapshot);
          // console.log(isPaidUser, "isPaidUser")
          navigate("/projects");
          toast.success("Welcome! You have successfully signed in.");
        } else {
          // console.log(isPaidUser, "isPaidUser")
          setUserId(isPaidUser?.id);
          toast("You need to pay for sign in");

          setIsModalVisible(true);
          setLoading(false);
        }
      })
      .catch((error) => {
        setLoading(false);
        toast.error(error.message);
      });
  };

  useEffect(() => {
    props.user && navigate("/projects");
  }, [props.user]);

  return (
    <SignIn
      email={email}
      password={password}
      handleChange={handleChange}
      onSignIn={handleSubmit}
      loading={loading}
      setLoading={setLoading}
      isModalVisible={isModalVisible}
      setIsModalVisible={setIsModalVisible}
      userId={userId}
      setUserId={setUserId}
    />
  );
};

export default compose(
  connect(null, { setUser }),
  withFirebase
)(SignInContainer);
